import { useContext, useState, useEffect } from "react";
import SidePopup from "../side-popup";
import Card from "../cards/card";
import { stringToFriendlyDatetime } from "../../lib/helpers/datetime-helpers";
import PopupContext from "../../context/context-popup";

export default function NotificationItem() {
    const { setPopup, closePopup } = useContext(PopupContext);
    const [ notifications, setNotifications ] = useState([]);

    const popup = () => {
        setPopup(
            <SidePopup
                title={'Notifications'}
                onClose={closePopup}
            >
                {
                    notifications.map((item, index) => {
                        const text = notificationDescription(item)
                        return(
                            <Card
                                key={index}
                                id={text.description}
                                description={text.title}
                                link={text.link}
                                read={item?.read_by?.length > 0}
                                meta={`${stringToFriendlyDatetime(item.created_at)}`}
                            />
                        );
                    })
                }
            </SidePopup>
        )
    }

    useEffect(() => {

    }, []);

    return (
        <div className="topbar-menu__icon" onClick={popup}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24"
                    height="24" viewBox="0 0 24 24">
                <path id="Path_218" data-name="Path 218"
                        d="M20,17h2v2H2V17H4V10a8,8,0,0,1,16,0Zm-2,0V10A6,6,0,0,0,6,10v7ZM9,21h6v2H9Z"
                        fill="#fcf7ff"/>
            </svg>
            { notifications?.length > 0 && <div style={{
                position: 'absolute',
                top: '-5px',
                right: '-5px',
                width: '25px',
                height: '25px',
                background: '#1577EA',
                borderRadius: '50%',
                color: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                { notifications?.length }
            </div> }
        </div>
    )
}